export function getPublicApiAuthToken() {
  return process.env.VUE_APP_WEBSITE_AUTH_TOKEN || 'hx1v3BKihvERof3eD1Wi7iynAUO5Z6vzVQIo3GNCMQ0-'
}

export function publicApiAuthHeaders() {
  const token = getPublicApiAuthToken()

  return token ? { Authorization: token } : {}
}
